import { makeStyles } from '@material-ui/core/styles';

export default (styles, options = {}) => makeStyles(styles, options)();
